const API_BASE_URL = 'https://api.realitni-jestrab.cz'

export const handleCommentSubmit = async (comment, propertyId, setProperty, setComment) => {
  if (!comment.trim()) return

  try {
    const response = await fetch(`${API_BASE_URL}/api/property/${propertyId}/comment`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ comment }),
    })
    console.log('response', response)
    if (response.ok) {
      setProperty((prev) => ({
        ...prev,
        comments: [...(prev.comments || []), { text: comment, date: new Date() }],
      }))
      setComment('')
    } else {
      console.error('Failed to submit comment')
    }
  } catch (error) {
    console.error('Error submitting comment:', error)
  }
}
export const handleGeneratePrompt = async (prompt, propertyId, setShowSubmitAnalysis) => {
  if (!prompt.trim()) return
  setShowSubmitAnalysis(true)
  try {
    const response = await fetch(`${API_BASE_URL}/api/property/${propertyId}/generatePrompt`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ promptDetails: prompt }),
    })

    if (response.ok) {
      const result = await response.json()
      console.log('Prompt generated successfully:', result)
    } else {
      console.error('Failed to generate prompt')
    }
  } catch (error) {
    console.error('Error generating prompt:', error)
  }
}
export const handleSubmitAnalysis = async (analysis, propertyId, setShowSubmitAnalysis) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/property/${propertyId}/completeAnalysis`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (response.ok) {
      const result = await response.json()
      console.log('Prompt generated successfully:', result)
    } else {
      console.error('Failed to generate prompt')
    }
  } catch (error) {
    console.error('Error generating prompt:', error)
  }
}

export const getValueForProperty = async (propertyId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/value`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ propertyId }),
    })
    if (!response.ok) throw new Error('Failed to fetch value')
    return await response.json()
  } catch (error) {
    console.error('Error fetching value:', error)
    throw error
  }
}
